import { Box, Button, Flex, IconButton, Input, Select, Text, Tooltip } from "@chakra-ui/react";
import { FaPlus, FaTrash } from "react-icons/fa";
import { crm } from "../../../theme";
import { BRAZIL_STATES, CommercialClientBranch } from "../../../models/CommercialClient";

const formatCnpj = (value?: string | null) => {
  const d = (value ?? "").replace(/\D/g, "").slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

/** Filiais do cliente (CNPJ + UF). No simulador, a UF da filial escolhe a exceção da parametrização fiscal. */
const BranchesEditor = ({
  branches,
  onChange,
}: {
  branches: CommercialClientBranch[];
  onChange: (branches: CommercialClientBranch[]) => void;
}) => {
  const patch = (index: number, value: Partial<CommercialClientBranch>) =>
    onChange(branches.map((b, i) => (i === index ? { ...b, ...value } : b)));

  return (
    <Box mt="22px">
      <Flex align="center" justify="space-between" mb="8px">
        <Box>
          <Text fontSize="sm" color={crm.textMuted}>Filiais</Text>
          <Text fontSize="xs" color={crm.textFaint}>
            A UF escolhe as alíquotas (ST, MVA, DIFAL) da parametrização no simulador. Inclua a matriz se ela também compra.
          </Text>
        </Box>
        <Button
          size="xs"
          leftIcon={<FaPlus />}
          variant="outline"
          onClick={() => onChange([...branches, { cnpj: "", state: "" }])}
        >
          Filial
        </Button>
      </Flex>
      {branches.length === 0 && (
        <Text fontSize="sm" color={crm.textFaint} py="6px">Nenhuma filial cadastrada.</Text>
      )}
      {branches.map((branch, index) => (
        <Box key={branch.id ?? `new-${index}`} border="1px solid" borderColor={crm.border} borderRadius="10px" p="10px" mb="8px">
          <Flex gap="8px" wrap="wrap">
            <Input
              size="sm"
              flex="1 1 140px"
              placeholder="Nome (ex.: Filial PR)"
              maxLength={120}
              value={branch.name ?? ""}
              onChange={(e) => patch(index, { name: e.target.value })}
            />
            <Input
              size="sm"
              flex="1 1 170px"
              placeholder="CNPJ"
              value={formatCnpj(branch.cnpj)}
              onChange={(e) => patch(index, { cnpj: e.target.value.replace(/\D/g, "").slice(0, 14) })}
              isInvalid={(branch.cnpj ?? "").length > 0 && (branch.cnpj ?? "").length !== 14}
            />
            <Select
              size="sm"
              w="84px"
              placeholder="UF"
              value={branch.state ?? ""}
              onChange={(e) => patch(index, { state: e.target.value })}
            >
              {BRAZIL_STATES.map((uf) => <option key={uf} value={uf}>{uf}</option>)}
            </Select>
            <Tooltip label="Remover filial">
              <IconButton size="sm" variant="ghost" color={crm.danger} aria-label="Remover filial" icon={<FaTrash />} onClick={() => onChange(branches.filter((_, i) => i !== index))} />
            </Tooltip>
          </Flex>
        </Box>
      ))}
    </Box>
  );
};

export default BranchesEditor;
